























import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';


export default Vue.extend({
	name: 'HealthCard',
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			colors: ['green', 'orange', 'red'],
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
